import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Chat = ({
  height = 19,
  width = 20,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix width={width} height={height} viewBox="0 0 20 19" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.6875 1.75C2.58804 1.75 2.49266 1.78951 2.42233 1.85983C2.35201 1.93016 2.3125 2.02554 2.3125 2.125V11.125C2.3125 11.2245 2.35201 11.3198 2.42233 11.3902C2.49266 11.4605 2.58804 11.5 2.6875 11.5H4.9375C5.35171 11.5 5.6875 11.8358 5.6875 12.25V14.125L6.7375 13.3375C7.06887 13.089 7.53897 13.1561 7.7875 13.4875C8.03603 13.8189 7.96887 14.289 7.6375 14.5375L5.3875 16.225C5.16024 16.3954 4.85618 16.4229 4.60209 16.2958C4.348 16.1688 4.1875 15.9091 4.1875 15.625V13H2.6875C2.19022 13 1.71331 12.8025 1.36167 12.4508C1.01004 12.0992 0.8125 11.6223 0.8125 11.125V2.125C0.8125 1.62772 1.01004 1.15081 1.36167 0.799175C1.71331 0.447544 2.19022 0.25 2.6875 0.25H15.0625C15.5598 0.25 16.0367 0.447544 16.3883 0.799175C16.74 1.1508 16.9375 1.62772 16.9375 2.125V5.5C16.9375 5.91421 16.6017 6.25 16.1875 6.25C15.7733 6.25 15.4375 5.91421 15.4375 5.5V2.125C15.4375 2.02554 15.398 1.93016 15.3277 1.85983C15.2573 1.78951 15.162 1.75 15.0625 1.75H2.6875Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1875 4.375C4.1875 3.96079 4.52329 3.625 4.9375 3.625H12.8125C13.2267 3.625 13.5625 3.96079 13.5625 4.375C13.5625 4.78921 13.2267 5.125 12.8125 5.125H4.9375C4.52329 5.125 4.1875 4.78921 4.1875 4.375Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.1875 7.75C4.1875 7.33579 4.52329 7 4.9375 7H7.1875C7.60171 7 7.9375 7.33579 7.9375 7.75C7.9375 8.16421 7.60171 8.5 7.1875 8.5H4.9375C4.52329 8.5 4.1875 8.16421 4.1875 7.75Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.6875 7.75C8.6875 7.33579 9.02329 7 9.4375 7H18.4375C18.8517 7 19.1875 7.33579 19.1875 7.75V14.5C19.1875 14.9142 18.8517 15.25 18.4375 15.25H16.9375V17.875C16.9375 18.1783 16.7548 18.4518 16.4745 18.5679C16.1943 18.684 15.8717 18.6198 15.6572 18.4053L12.5018 15.25H9.4375C9.02329 15.25 8.6875 14.9142 8.6875 14.5V7.75ZM10.1875 8.5V13.75H12.8125C13.0114 13.75 13.2022 13.829 13.3428 13.9697L15.4375 16.0643V14.5C15.4375 14.0858 15.7733 13.75 16.1875 13.75H17.6875V8.5H10.1875Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3125 11.125C11.3125 10.7108 11.6483 10.375 12.0625 10.375H15.8125C16.2267 10.375 16.5625 10.7108 16.5625 11.125C16.5625 11.5392 16.2267 11.875 15.8125 11.875H12.0625C11.6483 11.875 11.3125 11.5392 11.3125 11.125Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
